import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import format from 'date-fns/format';
import { inject, observer } from 'mobx-react';
import { withRouter } from 'react-router-dom';

import Container from '../../components/Container';
import Scene from '../Scene';
import {
  crossScreenMarginBottom,
  crossScreenPaddingBottom,
  crossScreenPaddingTop,
  toVw,
  toVwMobile,
  toVwTablet,
} from '../../utils/styles';
import Indent from '../../components/Indent';
import { FONT_SIZE_LARGE } from '../../constants';
import ContentItems from '../../components/ContentItems';
import PreviewNext from '../../components/PreviewNext';
import mq from '@/utils/media-queries';
import withBackLink from '../../components/withBackLink';
import NotFound from '../NotFound';
import AnimationOnPageLoadItem from '../../components/AnimationOnPageLoadItem';

const PostScene = styled(Scene)`
  ${crossScreenPaddingTop(288)};
`;

const RelativeIndent = styled(Indent)`
  position: relative;
`;

const Header = styled.div`
  ${crossScreenMarginBottom(104)};

  ${mq.mobile(css`
    position: relative;
    padding-left: ${toVwMobile(100)};
  `)};
`;

const Avatar = styled.img`
  position: absolute;
  left: ${toVw(36)};
  top: 0;
  width: ${toVw(120)};
  height: ${toVw(120)};
  border-radius: 50%;

  ${mq.tablet(css`
    left: 0;
    top: ${toVwTablet(3)};
    width: ${toVwTablet(80)};
    height: ${toVwTablet(80)};
  `)};

  ${mq.mobile(css`
    width: ${toVwMobile(70)};
    height: ${toVwMobile(70)};
  `)};
`;

const TitleWrapper = styled.div`
  margin-bottom: ${toVw(40)};
`;

const titleBase = css`
  font-size: ${toVw(FONT_SIZE_LARGE)};
`;

const Title = styled.h1`
  ${titleBase};
  font-weight: 300;
`;

const Subtitle = styled.div`
  ${titleBase};
`;

const Content = styled.div`
  ${crossScreenPaddingBottom(264)};
`;

class NewsPost extends React.Component {
  static propTypes = {
    postStore: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired,
    withTransition: PropTypes.bool,
    animationRunning: PropTypes.bool,
    logoStore: PropTypes.object.isRequired,
  };

  componentDidMount() {
    const slug = this.props.match.params.slug;
    this.props.postStore.load(slug);
  }

  componentWillReceiveProps(nextProps) {
    const slug = nextProps.match.params.slug;
    if (this.props.match.params.slug !== slug) {
      this.props.postStore.load(slug);
    }
  }

  render() {
    if (this.props.postStore.notFound) {
      return <NotFound />;
    }

    const { avatar, title, subtitle, timestamp, content, nextPreview } = this.props.postStore.entity.toJSON();

    return (
      <PostScene data-test="post" {...this.props}>
        <Container>
          <RelativeIndent>
            <AnimationOnPageLoadItem>
              <Header>
                {avatar && <Avatar src={avatar} />}
                <TitleWrapper>
                  <Title>{title}</Title>
                  <Subtitle>{subtitle}</Subtitle>
                </TitleWrapper>
                {timestamp && <div>{format(new Date(timestamp), 'DD MMM YYYY').toLowerCase()}</div>}
              </Header>
            </AnimationOnPageLoadItem>
          </RelativeIndent>
          <Content>
            <ContentItems items={content} />
          </Content>
        </Container>
        {nextPreview && nextPreview.to && <PreviewNext {...nextPreview} />}
      </PostScene>
    );
  }
}

const NewsPostWithBackLink = withBackLink('новостям')(observer(NewsPost));

export default withRouter(
  inject(stores => ({
    postStore: stores.store.post,
    logoStore: stores.store.logoStore,
  }))(NewsPostWithBackLink)
);



// WEBPACK FOOTER //
// ./src/scenes/NewsPost/index.js